// extracted by mini-css-extract-plugin
export default {"content":"Title_content__suvdE","body":"Title_body__Exld+"};